export const AddScriptLibrary = (urlOfTheLibrary) => {
    const script = document.createElement('script');
    script.type = "text/javascript";
    script.src = urlOfTheLibrary;
    script.async = true;
    document.head.appendChild(script);
}

export const isEmpty = (obj) => {
    for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false
    }

    return true
}

export function numberFormat(num) {
    return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
}

export function formatDateOnly(value) {
    return new Date(value).toISOString().slice(0, 10)
}

export function formatFullDate(value) {
    const format = new Date(value).toJSON()
    return new Date(format).toUTCString().slice(0, 17);
}

export const onlyAlphabet = (evt) => {
    const theEvent = evt || window.event;
    const key = theEvent.keyCode || theEvent.which;

    const keychar = String.fromCharCode(key);
    const keycheck = /[a-zA-z\s]/;

    if (!(key === 8 || key === 27 || key === 46 || key === 9 || key === 39 || key === 94)) // backspace delete  escape arrows
    {
        if (!keycheck.test(keychar)) {
            theEvent.returnValue = false;//for IE
            if (theEvent.preventDefault)
                theEvent.preventDefault();//Firefox
        }
    }
    else if(key===94)
        theEvent.preventDefault();
}

export const onlyNumeric = (evt) => {
    const theEvent = evt || window.event;
    const key = theEvent.keyCode || theEvent.which;

    const keychar = String.fromCharCode(key);
    const keycheck = /[0-9\s]/;

    if (!(key === 8 || key === 27 || key === 46 || key === 9 || key === 39 || key === 94)) // backspace delete  escape arrows
    {
        if (!keycheck.test(keychar)) {
            theEvent.returnValue = false;//for IE
            if (theEvent.preventDefault)
                theEvent.preventDefault();//Firefox
        }
    }
    else if(key===94)
        theEvent.preventDefault();
}

export const onlyNumeric_new = (evt) => {
    const theEvent = evt || window.event;
    const key = theEvent.keyCode || theEvent.which;

    const keychar = String.fromCharCode(key);
    const keycheck = /[1-3\s]/;

    if (!(key === 8 || key === 27 || key === 46 || key === 9 || key === 39 || key === 94)) // backspace delete  escape arrows
    {
        if (!keycheck.test(keychar)) {
            theEvent.returnValue = false;//for IE
            if (theEvent.preventDefault)
                theEvent.preventDefault();//Firefox
        }
    }
    else if(key===94)
        theEvent.preventDefault();
}